const DataStateEnum = Object.freeze({
    PENDING: 'PENDING',
    EMPTY: 'EMPTY',
    DATA: 'DATA'
});

export default DataStateEnum;
export const { PENDING, EMPTY, DATA } = DataStateEnum;
export function resolveDataLoadState(data) {
    if (typeof data === 'undefined') {
        return PENDING;
    }
    if (data.isEmpty()) {
        return EMPTY;
    }
    return DATA;
}
